import Responsive from "components/Responsive";
import React, { useCallback, useState } from "react";
import { breakpoints } from "theme/breakpoints";
import LargeDevicesDemonstration from "./LargeDevices";
import MediumDevicesDemonstration from "./MediumDevices";

const Demonstration: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const onTogglePromptHandler = useCallback(() => {
    setIsOpen((currentIsOpen) => !currentIsOpen);
  }, []);

  return (
    <>
      <Responsive minWidth={breakpoints.md}>
        <LargeDevicesDemonstration
          isOpen={isOpen}
          toggle={onTogglePromptHandler}
        />
      </Responsive>
      <Responsive maxWidth={breakpoints.md}>
        <MediumDevicesDemonstration
          isOpen={isOpen}
          toggle={onTogglePromptHandler}
        />
      </Responsive>
    </>
  );
};

export default Demonstration;
